import React, { useState } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { Xoa } from "./Xoa";

export const BtnXoa = ({ Id }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <a onClick={handleShow} href={() => false}>
        <PopoversBootrap
          contentText="Xoá"
          trigger={["hover", "focus"]}
          placement={"top"}
        >
          <img
                              style={{ marginLeft: "5px" }}
                              src="/app-assets/images/icon-xoa-v2.png"
                            />
        </PopoversBootrap>
      </a>
      {handleClose && <Xoa show={show} onHide={handleClose} Id={Id} />}
    </>
  );
};
